import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "architectural-diagram"
    }}>{`Architectural diagram`}</h1>
    <p>{`Depending upon your role and purpose for learning more about Adobe Commerce and Magento Open Source, there are several different ways to view the architecture. For example, a developer who wants to create new modules or perhaps customize an existing module will want to understand the architecture of a module itself, and how it fits into the larger view, with the Adobe Commerce and Magento Open Source framework (Commerce framework) and other components. However, a merchant who wants to quickly build an online storefront wants to view the collection of components from a higher level, and understand the components that impact the look, feel, and user interaction components.`}</p>
    <p>{`The following diagram illustrates the components and shows the "layers" or tiers in the Commerce framework.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "960px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "56.25%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "display": "block",
            "transition": "opacity 0.5s 0.5s",
            "pointerEvents": "none"
          }
        }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
            "srcSet": ["/commerce/php/static/aa799bf72bb7bb13bc6c84ec54fc7255/5530d/archi_diagram_desired-state.webp 320w", "/commerce/php/static/aa799bf72bb7bb13bc6c84ec54fc7255/0c8fb/archi_diagram_desired-state.webp 640w", "/commerce/php/static/aa799bf72bb7bb13bc6c84ec54fc7255/a6361/archi_diagram_desired-state.webp 960w"],
            "sizes": "(max-width: 960px) 100vw, 960px",
            "type": "image/webp"
          }}></source>{`
          `}<source parentName="picture" {...{
            "srcSet": ["/commerce/php/static/aa799bf72bb7bb13bc6c84ec54fc7255/dd4a7/archi_diagram_desired-state.png 320w", "/commerce/php/static/aa799bf72bb7bb13bc6c84ec54fc7255/0f09e/archi_diagram_desired-state.png 640w", "/commerce/php/static/aa799bf72bb7bb13bc6c84ec54fc7255/a91f8/archi_diagram_desired-state.png 960w"],
            "sizes": "(max-width: 960px) 100vw, 960px",
            "type": "image/png"
          }}></source>{`
          `}<img parentName="picture" {...{
            "className": "gatsby-resp-image-image",
            "src": "/commerce/php/static/aa799bf72bb7bb13bc6c84ec54fc7255/a91f8/archi_diagram_desired-state.png",
            "alt": "Architectural Diagram",
            "title": "Architectural Diagram",
            "loading": "lazy",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "opacity": "0",
              "transition": "opacity 0.5s",
              "color": "inherit",
              "boxShadow": "inset 0px 0px 0px 400px none",
              "top": "0",
              "left": "0"
            }
          }}></img>{`
        `}</picture>{`
    `}</span></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      